import { createSelector } from 'reselect';

import { getModuleState } from '../reducers';

const getState = createSelector(getModuleState, state => state.userCollections);

const selectUserCollectionsStatus = createSelector(getState, state => state.status);
const selectUserCollections = createSelector(getState, state => state.userCollections);

export { selectUserCollections, selectUserCollectionsStatus };
